<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form inline>
        <!-- 款号 -->
        <el-form-item label="款号">
          <el-input
            v-model="dataForm.num"
            placeholder="请输入款号"
            @keyup.enter="getGoodsList(true)"
          >
		  <template #suffix>
		        <i class="el-input__icon el-icon-edit" @click="openTextDialogDetail(dataForm.num,'num')" style="cursor:pointer;"></i>
		  </template>
		  </el-input>
        </el-form-item>
		<el-form-item label="商品分类">
          <el-select v-model="dataForm.class_id" placeholder="请选择商品分类">
			  <el-option
			    key=""
			    label=""
			    value=""
			  >
			  </el-option>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="商品上架状态">
          <el-select v-model="dataForm.status" placeholder="请选择上架状态">
			  <el-option
			    key=""
			    label=""
			    value=""
			  >
			  </el-option>
			  <el-option
			    key="1"
			    label="上架"
			    value="1"
			  >
			  </el-option>
			  <el-option
			    key="2"
			    label="下架"
			    value="2"
			  >
			  </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="商品全部-置顶状态">
          <el-select v-model="dataForm.is_top" placeholder="请选择置顶状态">
			  <el-option
			    key=""
			    label=""
			    value=""
			  >
			  </el-option>
			  <el-option
			    key="1"
			    label="置顶"
			    value="1"
			  >
			  </el-option>
			  <el-option
			    key="2"
			    label="不置顶"
			    value="2"
			  >
			  </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="商品分类-置顶状态">
          <el-select v-model="dataForm.is_category_top" placeholder="请选择置顶状态">
			  <el-option
			    key=""
			    label=""
			    value=""
			  >
			  </el-option>
			  <el-option
			    key="1"
			    label="置顶"
			    value="1"
			  >
			  </el-option>
			  <el-option
			    key="2"
			    label="不置顶"
			    value="2"
			  >
			  </el-option>
          </el-select>
        </el-form-item>
        <!-- zb_num -->
        <el-form-item label="直播号">
          <el-input
            v-model="dataForm.zb_num"
            placeholder="请输入直播号"
            @keyup.enter="getGoodsList(true)"
          ></el-input>
        </el-form-item>
        <!-- 名称 -->
        <el-form-item label="商品名称">
          <el-input
            v-model="dataForm.title"
            placeholder="请输入商品名称"
            @keyup.enter="getGoodsList(true)"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="primary" @click="getGoodsList(true)"
            >查询</el-button
          >
        </el-form-item>
		
		<el-form-item>
		  <el-button size="mini" type="primary" @click="resetGoodsList()"
		    >重置</el-button
		  >
		</el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 20px">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handelAdd"
          >添加</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-update"
          size="mini"
          @click="handleDeleteSelected('updateNum')"
          >批量修改分类</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-update"
          size="mini"
          @click="handleDeleteSelected('updateStatus')"
          >批量上下架</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-update"
          size="mini"
          @click="handleDeleteSelected('updateIsTop')"
          >批量修改全部-置顶状态</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-update"
          size="mini"
          @click="handleDeleteSelected('updateIsCategoryTop')"
          >批量修改分类-置顶状态</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          @click="handleDeleteSelected"
          >批量删除商品</el-button
        >
      </div>
      <el-table stripe border :data="list" 
      @selection-change="handleSelectionChange">
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        ></el-table-column>
		
		<el-table-column
			type="selection"
			width="55">
		  </el-table-column>
		  
        <el-table-column prop="class_id" label="分类名称" align="center">
          <template slot-scope="scope">
            {{ classMap[scope.row.class_id] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="商品名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="num"
          label="款号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="价格"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.img.split(',')[0]"
              style="width: 80px; height: 80px"
              :preview-src-list="scope.row.img.split(',')"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="上架状态" align="center" width="140">
          <template slot-scope="scope">
            <el-switch
              @change="(e) => updateStatus(e, scope.row)"
              v-model="scope.row.status"
              active-value="1"
              inactive-value="2"
              active-text="上架"
              inactive-text="下架"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="全部-是否置顶" align="center" width="160">
          <template slot-scope="scope">
            <el-switch
              @change="(e) => handleTopSave(e, scope.row)"
              v-model="scope.row.is_top"
              active-value="1"
              inactive-value="2"
              active-text="置顶"
              inactive-text="不置顶"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="分类-是否置顶" align="center" width="160">
          <template slot-scope="scope">
            <el-switch
              @change="(e) => handleCategoryTopSave(e, scope.row)"
              v-model="scope.row.is_category_top"
              active-value="1"
              inactive-value="2"
              active-text="置顶"
              inactive-text="不置顶"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="handelEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-document-copy"
              size="mini"
              @click="handelCopy(scope.row)"
              >复制</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteGoods(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[5, 10, 20, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handelSizeChange"
        @current-change="handelPage"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑商品 -->
    <el-dialog
      :title="type == 1 ? '新增商品' : '编辑商品'"
      :visible.sync="dialogFormVisible"
      width="1400px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="商品分类">
          <el-select v-model="form.class_id" placeholder="请选择商品分类">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
            v-model="form.title"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品价格">
          <el-input
            type="number"
            v-model="form.price"
            placeholder="请输入商品价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品图片">
          <uploadImg :limit="5" v-model="form.img"></uploadImg>
        </el-form-item>
        <el-form-item label="商品款号">
          <el-input
            type="text"
            placeholder="请输入商品款号"
            v-model="form.num"
          ></el-input>
        </el-form-item>
        <el-form-item label="直播号">
          <el-input
            type="text"
            placeholder="请输入直播号"
            v-model="form.zb_num"
          ></el-input>
        </el-form-item>
		
		<el-form-item label="详情">
		  <el-input
		    type="textarea"
		    :rows="5"
		    placeholder="请输入商品详情"
		    v-model="form.content"
		  ></el-input>
		</el-form-item>
		
        <div style="margin-bottom: 20px">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAddContent"
            >添加内容</el-button
          >
        </div>
        <el-table border :data="content_list">
          <el-table-column label="标题" align="center">
            <template slot-scope="scope">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入标题"
                v-model="scope.row.title"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="内容" align="center" width="1000">
            <template slot-scope="scope">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="scope.row.val"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="handleDelContent(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitGoods">确定</el-button>
      </div>
    </el-dialog>

    <!-- 一键修改款号分类 -->
    <el-dialog
      title="一键修改款号分类"
      :visible.sync="showUpdateNum"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="updateNumForm" label-width="80px">
        
        <el-form-item label="修改分类" v-if="updateNumForm.updateFiled == 'class_id'">
          <el-select
            v-model="updateNumForm.class_id"
            placeholder="请选择修改分类"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改上下架状态"  v-if="updateNumForm.updateFiled == 'status'">
          <el-select
            v-model="updateNumForm.status"
            placeholder="请选择修改上下架状态"
          >
            <el-option
              key="1"
              label="上架"
              value="1"
            >
            </el-option>
            <el-option
              key="2"
              label="下架"
              value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改全部-置顶状态"  v-if="updateNumForm.updateFiled == 'is_top'">
          <el-select
            v-model="updateNumForm.is_top"
            placeholder="请选择修改全部置顶状态"
          >
            <el-option
              key="1"
              label="置顶"
              value="1"
            >
            </el-option>
            <el-option
              key="2"
              label="不置顶"
              value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改分类置顶状态"  v-if="updateNumForm.updateFiled == 'is_category_top'">
          <el-select
            v-model="updateNumForm.is_category_top"
            placeholder="请选择修改分类置顶状态"
          >
            <el-option
              key="1"
              label="置顶"
              value="1"
            >
            </el-option>
            <el-option
              key="2"
              label="不置顶"
              value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showUpdateNum = false">取消</el-button>
        <el-button type="primary" @click="submitUpdateNumForm">确定</el-button>
      </div>
    </el-dialog>
	
	<!-- 搜索超文本 -->
	<el-dialog
	    title="输入超文本信息"
	    :visible.sync="textDialogVisible"
	    width="30%"
	  >
	    <el-input
	      type="textarea"
	      :autosize="{ minRows: 2, maxRows: 4}"
	      placeholder="请输入内容"
	      v-model="textareaContent"
	    ></el-input>
	    <span slot="footer" class="dialog-footer">
	      <el-button @click="textDialogVisible = false">取 消</el-button>
	      <el-button type="primary" @click="textHandleConfirm">确 定</el-button>
	    </span>
	  </el-dialog>
	
  </div>
</template>

<script>
import {
  getGoodsData,
  editGoodsData,
  deleteGoodsData,
  getClassList,
  updateShopStatus,
  topSave,
  delShopList,
  topCategorySave
} from "@/api";
import uploadImg from "@/components/upload-img/index.vue";
export default {
  name: "Mall",
  components: {
    uploadImg,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogFormVisible: false,
      type: 1, //1添加 2编辑
      dataForm: {
        num: "",
        title: "",
        class_id: "",
		status:"",
		zb_num:"",
		is_top:"",
		is_category_top:"",
		zb_num:"",
      },
      form: {},
      options: [],
      //商品内容
      content_list: [
        {
          title: "",
          val: "",
        },
      ],
      updateNumForm: {
        type: 3,
        num: "",
        class_id: "",
        is_top: "",
        is_category_top: "",
        status: "",
        updateFiled: 'class_id',
      },
      showUpdateNum: false,
      classMap: {},
	  
	  textDialogVisible:false,
	  textareaContent:'',
	  textareaFiled:'',
	  
	  
      multipleSelection: [], // 存储选中的行
    };
  },
  mounted() {
    getClassList().then((res) => {
      this.options = res.data.map((item) => {
        this.classMap[item.id] = item.title;
        return {
          value: item.id,
          label: item.title,
        };
      });
      this.getGoodsList();
    });
  },
  methods: {
	// 当选择项发生变化时触发
	handleSelectionChange(val) {
		this.multipleSelection = val;
	},
    // 处理删除按钮点击事件
    handleDeleteSelected(type='delete') {
		if (!this.multipleSelection.length) {
			this.$message.warning('请至少选择一项');
			return;
		}
		switch(type){
			case "delete":
				this.deleteSelected();
				break;
			case "updateNum":
				this.handelUpdateNum();
				break;
			case "updateStatus":
				this.handelUpdateNum('status');
				break;
			case "updateIsTop":
				this.handelUpdateNum('is_top');
				break;
			case "updateIsCategoryTop":
				this.handelUpdateNum('is_category_top');
				break;
		}
	    
    },
	deleteSelected(){
		const idsToDelete = this.multipleSelection.map(item => item.id);
		let formData = new FormData();
		formData.append("ids", idsToDelete);
		this.$confirm(
				`此操作将永久删除选中商品, 是否继续?`,
				"提示",
				{
				  confirmButtonText: "确定",
				  cancelButtonText: "取消",
				  type: "warning",
				}
		)
		.then(() => {
		  delShopList(formData).then((res) => {
			if (res.code == 200) {
			  this.$message({
				type: "success",
				message: "删除成功!",
			  });
			  this.getGoodsList();
			}
		  });
		})
		.catch(() => {
		  this.$message({
			type: "info",
			message: "已取消删除",
		  });
		});
	},
	updateStatusSelected(){
		const idsToDelete = this.multipleSelection.map(item => item.id);
		let formData = new FormData();
		formData.append("ids", idsToDelete);
		this.$confirm(
				`此操作将永久删除选中商品, 是否继续?`,
				"提示",
				{
				  confirmButtonText: "确定",
				  cancelButtonText: "取消",
				  type: "warning",
				}
		)
		.then(() => {
		  delShopList(formData).then((res) => {
			if (res.code == 200) {
			  this.$message({
				type: "success",
				message: "删除成功!",
			  });
			  this.getGoodsList();
			}
		  });
		})
		.catch(() => {
		  this.$message({
			type: "info",
			message: "已取消删除",
		  });
		});
	},
	openTextDialogDetail(text,field){
		this.textareaContent = text;
		this.textareaFiled = field;
		this.textDialogVisible = true;
	},
	textHandleConfirm(){
		this.dataForm[this.textareaFiled] = this.textareaContent;
		this.textDialogVisible = false; 
	},
    handeldellist() {
      this.$prompt('请输入商品款号(多个款号用","分隔)', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let str = value.replace(/[,，]/g, ",");
          let formData = new FormData();
          formData.append("num", str);
          this.$confirm(
            `此操作将永久删除款号【${str}】的所有商品, 是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              delShopList(formData).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.getGoodsList();
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleTopSave(e, { id }) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("is_top", e);
      topSave(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getGoodsList();
        }
      });
    },
    handleCategoryTopSave(e, { id }) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("is_category_top", e);
      topCategorySave(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getGoodsList();
        }
      });
    },
    updateStatus(e, { id }) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("status", e);
      updateShopStatus(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getGoodsList();
        }
      });
    },
    submitUpdateNumForm() {
      // if (!this.updateNumForm.num) {
      //   this.$message.error("请输入商品款号");
      //   return;
      // }
      if (this.updateNumForm.updateFiled == 'class_id' && !this.updateNumForm.class_id) {
        this.$message.error("请选择商品分类");
        return;
      }
      if (this.updateNumForm.updateFiled == 'status' && !this.updateNumForm.status) {
        this.$message.error("请选择修改上下架状态");
        return;
      }
      if (this.updateNumForm.updateFiled == 'is_top' && !this.updateNumForm.is_top) {
        this.$message.error("请选择修改置顶状态");
        return;
      }
      if (this.updateNumForm.updateFiled == 'is_category_top' && !this.updateNumForm.is_category_top) {
        this.$message.error("请选择修改置顶状态");
        return;
      }
      let formData = new FormData();
      for (let key in this.updateNumForm) {
        formData.append(key, this.updateNumForm[key]);
      }
	  const idsToDelete = this.multipleSelection.map(item => item.id);
	  formData.append("ids", idsToDelete);
      editGoodsData(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.showUpdateNum = false;
          this.getGoodsList();
        }
      });
    },
    handelUpdateNum(type = 'class_id') {
      this.updateNumForm = {
        type: 3,
        num: "",
        class_id: "",
        is_top: "",
        is_category_top: "",
        status: "",
        updateFiled: type,
      };
      this.showUpdateNum = true;
    },
    handelCopy(row) {
      this.type = 1;
      this.form = { ...row };
      let arr1 = this.form.first_title.split("|;|");
      let arr2 = this.form.first_content.split("|;|");
      this.form.id = "";
      this.content_list = arr1.map((item, index) => {
        return {
          title: item,
          val: arr2[index],
        };
      });
      this.dialogFormVisible = true;
    },
    handelEdit(row) {
      this.type = 2;
      this.form = { ...row };
      let arr1 = this.form.first_title.split("|;|");
      let arr2 = this.form.first_content.split("|;|");
      this.content_list = arr1.map((item, index) => {
        return {
          title: item,
          val: arr2[index],
        };
      });
      this.dialogFormVisible = true;
    },
    submitGoods() {
      if (!this.form.class_id) {
        this.$message.error("请选择商品分类");
        return;
      }
      if (!this.form.title) {
        this.$message.error("请输入商品名称");
        return;
      }
      if (!this.form.price) {
        this.$message.error("请输入商品价格");
        return;
      }
      if (!this.form.num) {
        this.$message.error("请输入商品款号");
        return;
      }
      if (!this.form.zb_num) {
        this.$message.error("请输入直播号");
        return;
      }
      if (!this.form.img) {
        this.$message.error("请上传商品图片");
        return;
      }
      if (!this.content_list.length) {
        this.$message.error("请添加商品内容");
        return;
      }
      let isContentPass = true;
      this.content_list.forEach((item) => {
        if (!item.title || !item.val) {
          isContentPass = false;
        }
      });
      if (!isContentPass) {
        this.$message.error("请完善商品内容");
        return;
      }
      let content = this.content_list.filter((item) => {
        return item.title && item.val;
      });
      this.form.first_title = content.map((item) => item.title).join("|;|");
      this.form.first_content = content.map((item) => item.val).join("|;|");

      let formData = new FormData();
      formData.append("type", this.type);
      for (let key in this.form) {
        formData.append(key, this.form[key]);
      }
      editGoodsData(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.dialogFormVisible = false;
          this.getGoodsList();
        }
      });
    },
    handleDelContent(index) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.content_list.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleAddContent() {
      this.content_list.push({
        title: "",
        val: "",
      });
    },
    handelAdd() {
      this.form = {};
      this.content_list = [
        {
          title: "",
          val: "",
        },
      ];
      this.type = 1;
      this.dialogFormVisible = true;
    },
    deleteGoods({ id }) {
      this.$confirm("此操作将永久删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          deleteGoodsData(formData).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getGoodsList();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
	resetGoodsList(){
		this.dataForm = {
			num: "",
			title: "",
			class_id: "",
			status:"",
			zb_num:"",
			is_top:"",
			is_category_top:"",
		};
		this.getGoodsList(true);
	},
    getGoodsList(rest) {
      if (rest) {
        this.page = 1;
      }
      let formData = new FormData();
      formData.append("page", this.page);
      formData.append("size", this.pageSize);
      formData.append("num", this.dataForm.num);
      formData.append("title", this.dataForm.title);
      formData.append("class_id", this.dataForm.class_id);
      formData.append("status", this.dataForm.status);
      formData.append("zb_num", this.dataForm.zb_num);
      formData.append("is_top", this.dataForm.is_top);
      formData.append("is_category_top", this.dataForm.is_category_top);
      getGoodsData(formData).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    handelPage(val) {
      this.page = val;
      this.getGoodsList();
    },
    handelSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getGoodsList();
    },
  },
};
</script>

<style></style>
